import { useNavigate } from 'react-router-dom';
import './BarberSection.css';
import LuisferProfile from '@/assets/images/home/BarberSection/imageBarbero.jpg';

interface BarberSectionProps { onBooking: () => void; }
export default function BarberSection({ onBooking }: BarberSectionProps) {
  const navigate = useNavigate();
  return (
    <section id="barbero" className="barber-section py-24 md:py-32 relative overflow-hidden">
      <div className="barber-section-watermark hidden lg:block">LUISFER</div>
      <div className="max-w-5xl mx-auto px-4 md:px-8 relative z-10">
        <div className="text-center mb-14">
          <p className="barber-section-label mb-4">◆ El Maestro ◆</p>
          <h2 className="barber-section-title">El Barbero</h2>
          <div className="barber-section-divider" />
        </div>
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
          <div className="relative flex-shrink-0">
            <div className="barber-image-wrapper">
              <img src={LuisferProfile} alt="Luisfer maestro barbero" className="barber-image" />
              <div className="barber-image-frame" />
              <div className="barber-badge">
                <p className="barber-badge-text">Master</p>
                <p className="barber-badge-text">Barber</p>
              </div>
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="barber-name">Luisfer</h3>
            <p className="barber-role">Fundador &amp; Master Barber</p>
            <p className="barber-bio">Luisfer es un artista del grooming masculino con más de 10 años perfeccionando su oficio. Su filosofía combina las técnicas clásicas de barbería con las tendencias más modernas, creando resultados únicos que reflejan la personalidad de cada cliente.</p>
            <div className="grid grid-cols-3 gap-4 mb-8">
              {[{ value: '10+', label: 'Años' }, { value: '2K+', label: 'Clientes' }, { value: '★★★★★', label: 'Valoración' }].map((stat) => (
                <div key={stat.label} className="barber-stat-card">
                  <p className="barber-stat-value">{stat.value}</p>
                  <p className="barber-stat-label">{stat.label}</p>
                </div>
              ))}
            </div>
            <button onClick={() => navigate('/reservar')} className="barber-cta cursor-pointer">
              Reservar con Luisfer
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}